export const url_faq_add_instagram_profile = 'url_faq_add_instagram_profile';
export const url_faq_social_profile_not_in_list = 'url_faq_social_profile_not_in_list';
export const url_faq_reach_impressions = 'url_faq_reach_impressions';
export const url_faq_link_when_scheduling_ig_story = 'url_faq_link_when_scheduling_ig_story';
export const url_faq_subscription = 'url_faq_subscription';
export const url_faq_subscription_plan_information = 'url_faq_subscription_plan_information';
export const url_faq_how_to_auto_post_ig = 'url_faq_how_to_auto_post_ig';
export const url_faq_schedule_error_codes = 'url_faq_schedule_error_codes';
export const url_faq_why_we_ask_you_enable_two_factor_auth =
    'url_faq_why_we_ask_you_enable_two_factor_auth';
export const url_faq_why_do_I_get_error_when_trying_autopost =
    'url_faq_why_do_I_get_error_when_trying_autopost';
export const url_faq_media_library_add = 'url_faq_media_library_add';
export const url_faq_data_access_current_fb_profile_connected =
    'url_faq_data_access_current_fb_profile_connected';
export const url_faq_can_see_analytics_ig_promoted_posts =
    'url_faq_can_see_analytics_ig_promoted_posts';
export const url_faq_trial_information = 'url_faq_trial';
export const url_faq_scheduler_link_preview = 'url_faq_scheduler_link_preview';
export const url_faq_estimated_followers = 'url_faq_estimated_followers';
export const url_faq_estimated_followers_media_viewer = 'url_faq_estimated_followers_media_viewer';
export const url_faq_manually_update_ig_fb_connection = 'url_faq_manually_update_ig_fb_connection';
export const url_faq_twitter_impressions_data = 'url_faq_twitter_impressions_data';
export const url_faq_twitter_analytics = 'url_faq_twitter_analytics';
export const url_faq_scheduler_cross_post_cant_find_social_profile =
    'url_faq_scheduler_cross_post_cant_find_social_profile';
export const url_faq_instagram_business_profile = 'url_faq_instagram_business_profile';
export const url_faq_link_instagram_facebook_page = 'url_faq_link_instagram_facebook_page';
export const url_faq_editor_admin_facebook_page = 'url_faq_editor_admin_facebook_page';
export const url_faq_users_roles_difference = 'url_faq_users_roles_difference';
export const url_faq_label_media_library = 'url_faq_label_media_library';
export const url_faq_create_album = 'url_faq_create_album';
export const url_faq_autopost_stories = 'url_faq_autopost_stories';
export const url_faq_collaboration = 'url_faq_collaboration';
export const url_faq_create_save_captions_hashtags = 'url_faq_create_save_captions_hashtags';
export const url_faq_create_captions_ai = 'url_faq_create_captions_ai';
export const url_faq_schedule_reports = 'url_faq_schedule_reports';
export const url_faq_create_dashboard = 'url_faq_create_dashboard';
export const url_faq_add_social_profile = 'url_faq_add_social_profile';
export const url_faq_invite_user = 'url_faq_invite_user';
export const url_faq_group_comparative_table = 'url_faq_group_comparative_table';
export const url_faq_pricing_social_profile = 'url_faq_pricing_social_profile';
export const url_scheduler_unlock_permission = 'url_scheduler_unlock_permission';
//new scheduler
export const url_scheduler_master_caption_custom_restrictions =
    'url_scheduler_master_caption_custom_restrictions';

const faqUrls = {
    [url_faq_add_instagram_profile]:
        'I-want-to-add-my-Instagram-business-profile-to-Iconosquare-why-am-I-being-asked-to-log-into-Facebook-',
    [url_faq_social_profile_not_in_list]:
        'help-the-meta-social-profile-i-want-to-add-is-not-listed',
    [url_faq_reach_impressions]: 'The-Iconosquare-Guide-to-Reach-Impressions',
    [url_faq_link_when_scheduling_ig_story]:
        'How-can-I-add-a-link-when-scheduling-an-Instagram-Story',
    [url_faq_subscription]:
        'where-can-i-find-information-about-my-current-plan-plan-renewal-date-expiration-and-status',
    url_faq_alt_text: 'how-to-add-alt-text-to-my-photos',
    [url_faq_subscription_plan_information]: 'Subscription-Plan-Information',
    [url_faq_how_to_auto_post_ig]: 'How-to-schedule-an-automatic-post-for-Instagram',
    [url_faq_schedule_error_codes]: 'Scheduler-Error-Codes',
    [url_faq_why_we_ask_you_enable_two_factor_auth]:
        'Why-am-I-being-asked-to-turn-on-two-factor-authentication-on-my-Facebook-profile',
    [url_faq_why_do_I_get_error_when_trying_autopost]:
        'I-m-getting-an-error-message-while-trying-to-schedule-a-media-for-auto-posting-what-does-this-mean',
    [url_faq_media_library_add]:
        'What-photo-and-video-formats-does-Iconosquare-accept-on-Instagram-Facebook-and-Twitter',
    [url_faq_data_access_current_fb_profile_connected]:
        'Data-access-page-What-is-the-Current-Facebook-profile-connected-information',
    [url_faq_can_see_analytics_ig_promoted_posts]:
        'Can-I-see-analytics-for-my-Instagram-promoted-posts-on-Iconosquare',
    [url_faq_trial_information]: 'Trial-Information',
    [url_faq_scheduler_link_preview]: 'link-previews-on-your-twitter-and-linkedin-scheduled-posts',
    [url_faq_estimated_followers]: 'why-can-t-i-see-my-full-instagram-follower-evolution-history',
    [url_faq_estimated_followers_media_viewer]: 'learn-more-historical-and-estimated-data',
    [url_faq_manually_update_ig_fb_connection]: 'manually-updating-your-facebook-ig-connection',
    [url_faq_twitter_impressions_data]:
        'Why-is-my-Twitter-Impressions-data-on-Iconosquare-different-from-what-I-m-seeing-on-Twitter-s-native-data',
    [url_faq_twitter_analytics]: 'Twitter-Analytics-on-Iconosquare-Frequently-Asked-Questions',
    [url_faq_scheduler_cross_post_cant_find_social_profile]:
        'why-doesn-t-the-profile-i-want-to-cross-post-to-appear-as-an-option',
    [url_faq_instagram_business_profile]:
        'How-to-convert-your-Instagram-account-to-an-Instagram-Business-Profile',
    [url_faq_link_instagram_facebook_page]: 'How-to-link-your-Instagram-profile-to-a-Facebook-page',
    [url_faq_editor_admin_facebook_page]:
        'How-can-I-check-if-I-am-the-Admin-or-Editor-of-a-Facebook-page',
    [url_faq_users_roles_difference]: 'what-are-the-different-roles-in-the-users-and-roles-section',
    [url_faq_label_media_library]: 'how-can-i-add-a-label-to-one-of-my-media-in-my-media-library',
    [url_faq_create_album]: 'how-can-i-create-an-album-for-my-media',
    [url_faq_autopost_stories]: 'autopost-your-instagram-stories-on-iconosquare',
    [url_faq_collaboration]: 'how-does-the-collaboration-feature-work',
    [url_faq_create_save_captions_hashtags]:
        'how-to-create-and-use-saved-captions-and-hashtag-lists',
    [url_faq_create_captions_ai]: 'easily-create-your-captions-with-ai',
    [url_faq_schedule_reports]: 'how-can-i-set-up-and-schedule-xls-and-pdf-reports-on-iconosquare',
    [url_faq_create_dashboard]: 'how-can-i-create-a-dashboard',
    [url_faq_invite_user]: 'how-can-i-invite-a-new-user-to-my-account',
    [url_faq_add_social_profile]: 'how-can-i-add-a-social-profile-to-my-account',
    [url_faq_group_comparative_table]: 'how-to-use-analytics-for-a-group-of-profiles',
    [url_faq_pricing_social_profile]: 'what-is-iconosquare-s-pricing',
    url_ig_post_collaboration: 'iconosquare-introduces-instagram-post-collaborators-feature',
    [url_scheduler_unlock_permission]: '',
    [url_scheduler_master_caption_custom_restrictions]: 'master-caption-custom-restrictions' // TODO: Update this URL with the correct one
};

export default faqUrls;
